import { gql } from 'apollo-angular';

const GET_UPLOAD_FIELDS = gql`
  mutation assignableFields(
    $uploadIdentifier: String!
    $uploadRequestId: Long!
    $sheet: SheetRequest!
    $resourceId: Long!
  ) {
    assignableFields(
      assignableFieldsRequest: {
        uploadType: "OFFER_PRICING_FILE"
        uploadIdentifier: $uploadIdentifier
        uploadRequestId: $uploadRequestId
        sheet: $sheet
        resourceId: $resourceId
      }
    ) {
      assignableFields {
        name
        displayName
        dataType
        required
      }
      rows {
        headerIndex
        rowValues {
          rowIndex
          headerColumns {
            columnHeader
            mapFieldName
          }
        }
      }
    }
  }
`;

export default GET_UPLOAD_FIELDS;
